import React from "react";
import { SimpleSearchableSelect } from "./SimpleSearchableSelect";
import { SelectOption } from "./types";

interface DesktopSelectProps {
  value: string;
  onValueChange: (value: string, option?: SelectOption) => void;
  options: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  error?: boolean;
  required?: boolean;
  searchable?: boolean;
  searchPlaceholder?: string;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  isSearching?: boolean;
  customOptionRenderer?: (option: SelectOption) => React.ReactNode;
  maxHeight?: string;
  showDescriptions?: boolean;
  highZIndex?: boolean;
}

export const DesktopSelect: React.FC<DesktopSelectProps> = (props) => {
  // All desktop selects use the simple searchable implementation
  return <SimpleSearchableSelect {...props} />;
};
